import type { ReactNode } from "react";
import { cn } from "../../../components/ui/cn";

export interface ResponsiveColumn {
  id: string;
  label: string;
  center?: boolean;
}

export interface ResponsiveCell extends ResponsiveColumn {
  node: ReactNode;
}

interface ResponsiveHeaderProps {
  gridClassName: string;
  columns: ResponsiveColumn[];
}

interface ResponsiveRowProps {
  gridClassName: string;
  primary: ReactNode;
  cells: ResponsiveCell[];
  className?: string;
}

export function ResponsiveHeader({ gridClassName, columns }: ResponsiveHeaderProps) {
  return (
    <div
      className={cn(
        "hidden gap-3 border-b border-line px-4 py-2.5 text-[11px] font-medium text-content-faint lg:grid",
        gridClassName,
      )}
    >
      {columns.map((column) => (
        <span key={column.id} className={cn(column.center && "text-center")}>
          {column.label}
        </span>
      ))}
    </div>
  );
}

export default function ResponsiveRow({
  gridClassName,
  primary,
  cells,
  className,
}: ResponsiveRowProps) {
  return (
    <div
      className={cn(
        "grid grid-cols-1 gap-3 border-b border-line px-4 py-3 last:border-b-0 lg:items-center",
        gridClassName,
        className,
      )}
    >
      <div className="min-w-0">{primary}</div>
      <div className="grid grid-cols-2 gap-x-3 gap-y-2.5 lg:contents">
        {cells.map((cell) => (
          <div key={cell.id} className={cn("min-w-0", cell.center && "lg:flex lg:justify-center")}>
            <span className="mb-1 block text-[10px] font-medium text-content-faint lg:hidden">
              {cell.label}
            </span>
            {cell.node}
          </div>
        ))}
      </div>
    </div>
  );
}
